module.exports = {
	"about": "About",
	"accepted_invitation_from": "You accepted invitation from  {invitedBy} and earned {coins} as joining bonus",
	"accepted_invitation_from_friend": "Your friend {displayName} accepted your invitation! You earned {coins} as bonus",
	"account_disabled": "Your Account Disabled, Please Contact hello@cricrush.com",
	"all_entries": "All Entries",
	"already_registered": "Already Registered? ",
	"can_t_find_account": "Oops, we couldn't find your account. Please create one!",
	"cant_placed_entries": "You haven't placed any entries",
	"change_profile_picture": "Change Profile Photo",
	"chat_modal_name": "Chat",
	"claim": "Claim",
	"click_here_to_resend": "Resend verification",
	"close": "Close",
	"coming_soon": "Coming Soon",
	"confirm": "Confirm",
	"countdown_day": "Day",
	"countdown_days": "Days",
	"countdown_hours": "Hours",
	"countdown_minutes": "Minutes",
	"countdown_seconds": "Seconds",
	"create_account": "Create Account",
	"cricrush_league": "Cricrush League",
	"do_not_have_an_account": "Do not have an account?",
	"dream_team": "Dream team",
	"dream_team_entry": "Dream Team Entry",
	"dream_team_entry_creation_modal_name": "Dream Team Entry Creation",
	"dream_team_leagues": "Dream Team Leagues",
	"earn_coins_bonuses": "Earn Coins Bonuses",
	"edition": "Edition",
	"email_not_verified": "Email not verified.",
	"email_not_verified_to_claim_rewards": "Please verify your email to claim rewards.",
	"email_title": "Email",
	"enter_valid_email": "Enter valid email",
	"entries": "Entries",
	"entry_created": " - ENTRY CREATED",
	"favourite_teams": "Favourite teams",
	"fb_reauth": "Confirm with facebook",
	"fb_signin": "Login with facebook",
	"fb_signup": "Signup with facebook",
	"fire_base_already_login_different provider": "You have previously signed up using different provider, please login using correct provider.",
	"fire_base_wrong_message": "Something went wrong, Please try again later!",
	"friend_invite_accepted": "Your friend {friendName} accepted your invitation",
	"ggl_reauth": "Confirm with google",
	"ggl_signin": "Login with google",
	"ggl_signup": "Signup with google",
	"go_back": "Go back",
	"help": "Help",
	"invalid_mail": "Invalid Email Address",
	"invitation_accepted": "Invitation Accepted!",
	"invitation_bonus": "Invitation bonus",
	"invite_friends": "Invite Friends",
	"leaderboard": "Leaderboard",
	"live": "Live",
	"live_prediction": "Live Prediction League",
	"live_prediction_entry": "Live Prediction Entry",
	"login": "Login",
	"login_here": "Login Here",
	"login_register": "Login/Register",
	"logout": "Logout",
	"lost": " - LOST",
	"lost_title": "Lost",
	"no_email_with_account": "No account associated with this email, Please Signup",
	"no_network": "No network!",
	"no_network_connection": "No network connection!",
	"notifications": "Notifications",
	"or": "OR",
	"password_incorrect": "The password you entered is incorrect.",
	"pick_your_country": "Pick your country",
	"play_button": "PLAY",
	"predict_score": "Predict the target score of the match",
	"profile": "Profile",
	"providers_str": "You used {providersStr} previously. Please login again using any of those method",
	"providers_str_try_google": "You signed up using {providersStr} previously. Try login using google",
	"reauth_modal_title": "Re-Authenticate to complete the action",
	"received_invitation_bonus": "Received invitation bonus",
	"refunded": " - REFUNDED",
	"refunded_title": "Refunded",
	"register_here": "Register Here",
	"save": "Save",
	"select_country": "Select the country and enjoy customized wins!",
	"select_language": "Select language",
	"select_teams": "Favourite teams",
	"settings": "Settings",
	"submit": "Submit",
	"target_prediction": "Target Prediction",
	"target_prediction_entry": "Target Prediction Entry",
	"total": "Total",
	"transactions": "Transactions",
	"unknown_error": "Unknown error occurred, Please contact us at hello@cricrush.com",
	"upcoming": "Upcoming",
	"user_name": "USERNAME",
	"valid_number": "Please enter a valid number!",
	"weak_password": "Weak password, The password must be 6 characters long or more.",
	"won": " - WON",
	"won_lost_refunded_coins": "Hey, You won  {earnedCoins} coins and lost {lostCoins} coins and got {refundedCoins} coins refunded.",
	"won_title": "Won",
	"you_lost_message": "You Lost",
	"you_won": "You Won",
	"you_won_reward": "You won a reward",
	"your_entries": "Your Entries",
	"your_live_prediction_entry": "Your Live Prediction Entry : {prediction}",
	"your_mom_entry": "Your Man of the match Entry:{momEntry}",
	"your_prediction": "Your prediction : {prediction}",
	"display_name": "Display Name",
	"email": "Email",
	"password": "Password",
	"runs_cannot_be_negative_value": "Runs cannot be a negative value",
	"budget": "Budget $",
	"view_button": " VIEW",
	"score": "Score: ",
	"rank": "Rank: ",
	"target_prediction_leagues": "Target Prediction Leagues",
	"live_prediction_leagues": "Live Prediction Leagues",
	"target_prediction_description": "Predict the target score of the match and place your entry. Your entries will be ranked based on their proximity to real score.",
	"required": "Required!",
	"entries_left": " entries left",
	"end_of_results": "End of results",
	"invalid_email_address": "Invalid Email Address",
	"completed": "Completed",
	"dream_team_description": "Pick your 4-player team and create your entry. Now sit back and enjoy the game while your team scores for you.",
	"reward_claimed_title": "Reward Claimed - {reference}",
	"reward_claimed_msg": "Redeemed coins by claiming reward with reference - {reference}",
	"update": "Update",
	"processed": "Processed",
	"claim_reward_instructions_title": "Please read instructions carefully!",
	"invalid_filed_instruction": "{field} is invalid. Please check!",
	"reward_processed": "Reward Processed!",
	"reward_reference": "Your Reference : {reference}",
	"claim_coins_message": "By claiming this reward, you will be reduced {claimCoins} coins.",
	"weekly": "Weekly",
	"daily": "Daily",
	"monthly": "Monthly",
	"lifetime": "Lifetime",
	"local": "Local",
	"global": "Global",
	"no_lb_status_generated": "We don't have enough data to generate this leader board!",
	"you": "You",
	"leaderBoard": "Leader Board",
	"mail_sent": "Email Sent!",
	"verification_mail_sent": "A verification email sent to {email}",
	"messages": "Messages",
	"country_change_warning": "You might loose current leader board ranks if you change your country.",
	"faq": "FAQ",
	"how_scores_calculated": "Score Calculations",
	"how_to_play": "How To Play",
	"live_prediction_description": "Predict the score at the end of {endOver}th over of {teamName}'s batting innings. Your entries will be ranked based on their proximity to real score.",
	"predict_what_message": "Predict the score at the end of {endOver}th over of {teamName}'s batting innings",
	"pick_team": "Pick your 4-player team and win",
	"your_entry_created": "Your entry created !",
	"fica_title": "Officially endorsed by",
	"fica_detailed_text": "Cricrush is the only fantasy cricket app endorsed by FICA",
	"version": "Version",
	"match_help": "Click here to select a match",
	"dream_team_leagues_help": "Click here to select your 4 player team for {matchName}",
	"quick_prediction_leagues_help": "Click here to predict the score at the end of {over}th over",
	"target_prediction_leagues_help": "Click here to predict the target score of {matchName} match",
	"entries_help": "Click here to view your entry scores and ranks updated in real time with live match",
	"more_leaderboard_help": "Click here to check your leaderboard",
	"more_edition_language_help": "Click here and select edition to change your language",
	"more_edition_country_help": "Click here and select edition to change your country",
	"add_coins_help": "Running out of coins? Earn more free coins here",
	"claimed": "Claimed",
	"invite_friends_title": "Invite your friends and get 100 coins when they place their first entry!",
	"daily_claim_bonus_counter_message": "You have already claimed your bonus!",
	"daily_claim_bonus_message": "Claim your free coins now!",
	"daily_login_bonus": "Daily login bonus",
	"daily_login_bonus_claimed": "Daily login bonus claimed",
	"invite_friends_share_title": "Your friend {name} has invited you to join Cricrush",
	"invite_friends_share_message": "Your friend {name} has invited you to join Cricrush. Click the link below to join, play and win exciting gifts",
	"invite_friends_dialog_title": "Invite friends to join",
	"live_status": "LIVE",
	"view_entries": "View {noOfEntries} entries >>",
	"end_of_results2": "That's all we have!",
	"leagues_not_created": "Leagues will be created soon...",
	"add_coins": "Add Coins",
	"expired": "Expired",
	"reward_expired": "Reward Expired!",
	"entries_left2": "{noOfEntries} entries left"
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = 486
// module chunks = 0